import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import legalEntityGeoprocessingReadAction from './legalEntityGeoprocessingRead.action.json' with { type: 'json' }

const legalEntityGeoprocessingReadDefinition = defineReadAutoAction(
  legalEntityGeoprocessingReadAction,
  'legalEntityGeoprocessing',
)

export default legalEntityGeoprocessingReadDefinition
